import { useOrganization } from '@/contexts/OrganizationContext';
import { useRole } from '@/hooks/use-role';

/**
 * Hook to manage Shopify configuration alert state
 * Shows alert when:
 * - User has org settings permission
 * - Organization has no Shopify domain configured
 * - Organization is NOT a pure-fulfilment 3PL provider (those intentionally
 *   operate without their own store — see BLU-367 / PR #1069)
 *
 * The alert prompts a retailer to connect Shopify; suppressing it for 3PL
 * providers avoids a permanent false "order sync will fail" nag.
 */
export function useShopifyConfigAlert() {
  const { organization, isLoading: orgLoading } = useOrganization();
  const { can } = useRole();

  const shouldShowAlert =
    !orgLoading &&
    can('org_settings.manage') &&
    organization !== null &&
    !organization.is_3pl_provider &&
    (!organization.shopify_domain || organization.shopify_domain.trim() === '');

  return {
    shouldShowAlert,
  };
}
